<script>
  import NameAttribute from "../modules/nameAttribute/index.svelte"
  import DropDown from "./dropDown.svelte"
  import defaultFonts from "../../stores/fileTemplateDefaultFonts"
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import FontsizeDropdown from "./fontsizeDropdown.svelte"
  import cursorPosition from "../../stores/cursorPosition"
  import notify from "../../../../../Script/notify"
  import { onMount } from "svelte"

  export let operation

  onMount(() => {
    if (!$defaultFonts.selectedFonts.includes(operation.fontFamily)) operation.fontFamily = "Arial"
  })

  let showAttributeModal = false
  /**
   * @type {Array} list of font family names
   */
  let fontSize = [20, 40, 60, 80, 100, 120, 140, 160, 180, 200]

  /**
   * @type {String} the default or active font family in the dropdown area
   */

  $: operation.x = Math.floor(operation.x)
  $: changeInputY(operation.y)
  const changeInputY = (y) => {
    operation.inputY = Math.floor($fileTemplateState.baseImageInfo.height - y)
  }
  const chooseColor = (e) => {
    $fileTemplateState.notifyFooter = "choose the color"
    operation.textColor = e.target.value //colorvalue = white
    $fileTemplateState.activeTextColor = e.target.value
  }

  $: if (operation.move) {
    operation.x = $cursorPosition.x
    operation.y = $fileTemplateState.baseImageInfo.height - $cursorPosition.y
  }

  const moveCursor = () => {
    let id = operation.id
    $fileTemplateState.operations = $fileTemplateState.operations.map((operation) => {
      operation.move = false
      if (operation.id == id) {
        $cursorPosition.x = operation.x
        $cursorPosition.y = $fileTemplateState.baseImageInfo.height - operation.y
        operation.move = true
      }
      return operation
    })
  }

  let maxCharacters = 120
  /**
   * @typedef {Object} maxNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {maxNotification}
   */
  let maxNotification = {
    close() {},
  }

  let timer
  /**
   * @description - function to check not to exceed max characters
   */
  const checkMaxCharacters = (e) => {
    if (operation.value) {
      if (operation.value.length >= maxCharacters) {
        maxNotification.close()
        timer = setTimeout(() => {
          operation.value = operation.value.slice(0, maxCharacters)
        }, 10)
        maxNotification = notify.info(`Layer value should not be more than ${maxCharacters} characters`)
      }
    }
  }
  const preventKeys = (e) => {
    const KEYS_TO_PREVENT = ["-", "+", "e", "E"]
    if (KEYS_TO_PREVENT.includes(e.key)) e.preventDefault()
  }
</script>

{#if showAttributeModal}
  <NameAttribute
    on:click={() => {
      showAttributeModal = false
    }}
    on:setLayer={(e) => {
      operation.attribute = e.detail.attribute

      operation.value = e.detail.value ? e.detail.value : "Text"
      showAttributeModal = false
    }}
    changeAttribute={true}
    parsedJson={$fileTemplateState.parsedJson}
  />
{/if}

<svelte:window on:keydown />

<div class="w-[383px] space-y-3 rounded-md bg-[#292A2F] p-6 {operation.errorX || operation.errorY ? 'border-2 border-red-500' : ''} {operation.active ? 'border-2 border-blue-500' : ''}">
  <div class="group relative w-full rounded-md">
    <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {operation.attribute ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
    <input
      on:keydown={(e) => {
        if (e.key == "Delete") {
          e.stopPropagation()
        }
      }}
      type="text"
      bind:value={operation.attribute}
      required
      placeholder="Choose Attribute"
      class="w-full select-none truncate rounded-md border border-stone-700 bg-transparent py-2 pl-16 pr-10 text-sm text-white outline-none invalid:animate-shake focus:ring-2 focus:ring-extraBlue-500 invalid:focus:ring-red-500"
    />
    <div class="absolute right-3 top-2.5 select-none text-sm font-bold text-white {operation.attribute ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="cursor-pointer"
        on:click={() => {
          showAttributeModal = true
        }}
        data-tooltip="Use attribute"
        tooltip-position="left"
      >
        <i class="fa-solid fa-brackets-curly" />
      </div>
    </div>
  </div>
  <div class="group relative w-full rounded-md">
    <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 group-focus-within:text-extraBlue-500">VALUE</div>
    <input
      on:keypress={checkMaxCharacters}
      on:paste={checkMaxCharacters}
      on:input={() => {
        clearTimeout(timer)
        maxNotification.close()
        timer = setTimeout(checkMaxCharacters, 50)
      }}
      on:keydown={(e) => {
        if (e.key == "Delete") {
          e.stopPropagation()
        }
      }}
      type="text"
      placeholder="Enter the text"
      bind:value={operation.value}
      class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500"
    />
  </div>

  <div class="flex gap-3">
    <DropDown dropdownItems={$defaultFonts.selectedFonts} bind:activeItem={operation.fontFamily} />
    <div class="w-32">
      <FontsizeDropdown dropdownItems={fontSize} bind:activeItem={operation.fontSize} />
    </div>
  </div>
  <div class="flex gap-3">
    <!-- input x -->
    <div class="group relative w-full rounded-md">
      {#if operation.errorX}
        <span class="absolute left-8 bottom-full mb-2 w-max rounded bg-yellow-400 px-2 py-1 text-black opacity-0 shadow transition group-hover:opacity-100">Fix this</span>
      {/if}
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {operation.errorX ? 'group-focus-within:text-red-500' : 'group-focus-within:text-extraBlue-500'}">X</div>
      <button
        on:click|preventDefault={() => {
          operation.x = operation.x + 10
        }}
        on:click|preventDefault={() => {
          if (operation.x + 10 <= $fileTemplateState.baseImageInfo.width) {
            operation.x = operation.x + 10
          } else {
            operation.x = $fileTemplateState.baseImageInfo.width // Stop at the width boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click|preventDefault={() => {
          if (operation.x - 10 >= 0) {
            operation.x = operation.x - 10
          } else {
            operation.x = 0 // Stop at the left boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>
      <!-- on:wheel|preventDefault|stopPropagation={(e) => {
          if (e.deltaY < 0) {
            operation.x = operation.x + 10
          } else {
            operation.x = operation.x - 10
          }
        }} -->
      <input
        min="0"
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        bind:value={operation.x}
        type="number"
        class="w-full select-none {operation.errorX ? 'border-red-500 focus:ring-red-500 peer-focus:ring-red-500' : 'border-stone-700 focus:ring-extraBlue-500 peer-focus:ring-extraBlue-500'} rounded-md border bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 peer-focus:ring-2"
        placeholder="10"
      />
    </div>
    <!-- input y -->

    <div class="group relative w-full rounded-md">
      {#if operation.errorY}
        <span class="absolute left-8 bottom-full mb-2 w-max rounded bg-yellow-400 px-2 py-1 text-black opacity-0 shadow transition group-hover:opacity-100">Fix this</span>
      {/if}
      <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {operation.errorY ? 'group-focus-within:text-red-500' : 'group-focus-within:text-extraBlue-500'}">Y</div>
      <button
        on:click={() => {
          if (operation.y - 10 >= 0) {
            operation.y = operation.y - 10
          } else {
            operation.y = 0 // Stop at the top boundary
          }
        }}
        class="peer absolute right-2 top-0 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-up fa-xs" />
      </button>
      <button
        on:click={() => {
          if (operation.y + 10 <= $fileTemplateState.baseImageInfo.height) {
            operation.y = operation.y + 10
          } else {
            operation.y = $fileTemplateState.baseImageInfo.height // Stop at the bottom boundary
          }
        }}
        class="peer absolute bottom-0 right-2 cursor-pointer text-gray-g00 hover:text-extraBlue-500"
      >
        <i class="fa-solid fa-chevron-down fa-xs" />
      </button>

      <input
        min="0"
        on:input={(e) => {
          operation.y = $fileTemplateState.baseImageInfo.height - e.target.value
        }}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:keypress={preventKeys}
        bind:value={operation.inputY}
        type="number"
        class="w-full select-none rounded-md border {operation.errorY ? 'border-red-500 focus:ring-red-500 peer-focus:ring-red-500' : 'border-stone-700 focus:ring-extraBlue-500 peer-focus:ring-extraBlue-500'} bg-transparent py-2 pl-10 pr-8 text-sm text-white outline-none focus:ring-2 peer-focus:ring-2"
        placeholder="10"
      />
    </div>

    <button on:click={moveCursor} data-tooltip="Move" tooltip-position="top" class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none focus:ring-2 focus:ring-extraBlue-500 active:bg-extraBlue-500">
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-arrow-pointer" />
      </span>
    </button>
  </div>

  <div class="flex justify-between">
    <button
      on:click={() => {
        operation.textAlign = "left"
        $fileTemplateState.activeTextAlign = "left"
      }}
      data-tooltip="Align left"
      tooltip-position="top"
      class="flex items-center {operation.textAlign == 'left' ? 'bg-zinc-900 ring-2 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-left" />
      </span>
    </button>
    <button
      on:click={() => {
        operation.textAlign = "center"
        $fileTemplateState.activeTextAlign = "center"
      }}
      data-tooltip="Align center"
      tooltip-position="top"
      class="flex items-center {operation.textAlign == 'center' ? 'bg-zinc-900 ring-2 ring-extraBlue-500' : ''}  rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-center" />
      </span>
    </button>
    <button
      on:click={() => {
        operation.textAlign = "right"
        $fileTemplateState.activeTextAlign = "right"
      }}
      data-tooltip="Align right"
      tooltip-position="top"
      class="flex items-center {operation.textAlign == 'right' ? 'bg-zinc-900 ring-2 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00 hover:bg-zinc-900 focus:outline-none"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-align-right" />
      </span>
    </button>

    <!-- on:click={() => {
        if (!operation.fontStyles.includes("Bold")) {
          operation.fontStyles = [...operation.fontStyles, "Bold"]
          $fileTemplateState.activeFontStyles = [...operation.fontStyles, "Bold"]
        } else {
          operation.fontStyles = operation.fontStyles.filter((font) => font !== "Bold")
          $fileTemplateState.activeFontStyles = $fileTemplateState.activeFontStyles.filter((font) => font !== "Bold")
        }
      }} -->
    <button
      on:click={() => {
        if (!operation.fontStyles.includes("Bold")) {
          operation.fontStyles = [...operation.fontStyles, "Bold"]
        } else {
          operation.fontStyles = operation.fontStyles.filter((font) => font !== "Bold")
        }
        $fileTemplateState.activeFontStyles = [...operation.fontStyles]
      }}
      data-tooltip="Bold"
      tooltip-position="top"
      class="flex items-center {operation.fontStyles.includes('Bold') ? 'bg-zinc-900 outline-none ring-2 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-bold" />
      </span>
    </button>
    <button
      on:click={() => {
        if (!operation.fontStyles.includes("Italic")) {
          operation.fontStyles = [...operation.fontStyles, "Italic"]
        } else {
          operation.fontStyles = operation.fontStyles.filter((font) => font !== "Italic")
        }
        $fileTemplateState.activeFontStyles = [...operation.fontStyles]
      }}
      data-tooltip="Italic"
      tooltip-position="top"
      class="flex items-center {operation.fontStyles.includes('Italic') ? 'bg-zinc-900 outline-none ring-2 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-italic" />
      </span>
    </button>
    <button
      on:click={() => {
        if (!operation.fontStyles.includes("Underline")) {
          operation.fontStyles = [...operation.fontStyles, "Underline"]
        } else {
          operation.fontStyles = operation.fontStyles.filter((font) => font !== "Underline")
        }
        $fileTemplateState.activeFontStyles = [...operation.fontStyles]
      }}
      data-tooltip="underline"
      tooltip-position="top"
      class="flex items-center {operation.fontStyles.includes('Underline') ? 'bg-zinc-900 outline-none ring-2 ring-extraBlue-500' : ''} rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-underline" />
      </span>
    </button>
    <button
      on:click={() => {
        operation.fontStyles = []
        $fileTemplateState.activeFontStyles = []
      }}
      data-tooltip="Remove Style"
      tooltip-position="top"
      class="flex items-center rounded-md border border-stone-700 bg-transparent p-2 text-lg text-gray-g00"
    >
      <span class="flex h-5 w-5 items-center justify-center">
        <i class="fa-solid fa-eraser" />
      </span>
    </button>
  </div>
  <div class="flex w-full items-center justify-between">
    {#each $fileTemplateState.baseImageInfo.palette as color}
      <div class="flex gap-3 p-[6.8px]">
        <button
          on:click={() => {
            operation.textColor = color
            $fileTemplateState.activeTextColor = color
          }}
          class="flex h-6 w-6 items-center rounded-full {operation.textColor == color ? 'ring-2 ring-white ring-offset-2 ring-offset-gray-700' : ''}"
          style="background:{color}"
        />
      </div>
    {/each}
    <div class="relative flex items-center p-[6.8px]">
      <img class="h-6 w-6 cursor-pointer rounded-full" src="assets/img/color-wheel.png" alt="" />
      <input
        on:change={() => {
          $fileTemplateState.baseImageInfo.palette = [...$fileTemplateState.baseImageInfo.palette, operation.textColor]

          $fileTemplateState.baseImageInfo.palette.shift()
        }}
        on:input={chooseColor}
        type="color"
        class="absolute inset-2 h-6 w-6 cursor-pointer opacity-0"
      />
    </div>
  </div>
</div>

<style global>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
